export enum StatusWeryfikacjiWOswiadczeniuODochodach {
  Zatwierdzono = 1,
  NieZatwierdzono,
  NieSprawdzono,
}
